if (!customElements.get("build-skate")) {
    class BuildSkate extends HTMLElement {
        constructor() {
            super();

            this.defaultContent         = this.querySelector(".js-default-content");
            this.ajaxContent            = this.querySelector(".js-ajax-content");
            // Popup product
            this.ajaxProduct            = this.querySelector(".js-popup-product");
            this.ajaxProductPopupClose  = this.querySelector(".js-popup-close");
            this.ajaxProductContent     = this.ajaxProduct?.querySelector(".js-popup-product-content");

            this.items                  = this.querySelectorAll(".js-card-select");
            this.btnAdds                = this.querySelectorAll(".js-card-add");
            this.btnRemoves             = this.querySelectorAll(".js-card-remove");
            this.btnBack                = this.querySelector(".js-btn-back");
            this.currentCard            = '';
            this.currentCollection      = '';
            this.currentProduct         = '';
            this.dataSkate              = [];
            this.totalPart              = this.dataset.totalPart;
            this.parts                  = this.dataset.parts.split(",");
            this.keyLS                  = "buildSkateDatas";
            this.bindEvents();
        }

        async bindEvents() {
            await this.handleFirstLoad();
            this.handleActions();
            this.handleSelectCardAjax();
            this.handleClearFilter();
            this.handleCheckout();

            // REVIEW
            this.toggleReviewBar();

            //SHARE / CLEAR / EXIT
            this.handleActionsBlock();
        }

        async handleFirstLoad() {
            this.reloadDataLStorage();

            if (window.location.href.includes("?data=copy&")) {
                console.log("handleFirstLoad");
                await this.checkCopyUrl();
            } else {
                console.log("nodata handleFirstLoad");
                this.updateCardImages();
            }

            this.renderData();
        }

        reloadDataLStorage() {
            this.dataSkate = this.getDataLStorage();
            this.checkCollectionChanged();
            this.checkBtnReviewAndAddToCart();
            this.updatePrice();
        }

        checkCollectionChanged() {
            const componentKeys = Object.keys(this.dataSkate);
            const unmatchedKeys = componentKeys.filter(key => !this.parts.includes(key));
            if (unmatchedKeys.length > 0) {
                this.createNewEmptyData()
            }
        }

        handleActions() {
            this.btnAdds.forEach(btn => {
                btn.addEventListener("click", (e) => {
                    const itemClicked = btn.closest('.js-card-select');
                    const card = itemClicked?.dataset.card;
                    const collection = itemClicked?.dataset.collection;
                    const product = itemClicked?.dataset.product;

                    this.currentCard = card;
                    this.currentCollection = collection;
                    this.currentProduct = product;


                    if (product) {
                        const url = `${window.routes.root}products/${product}`
                        this.setLoadingState(true);
                        this.showCardAjax(url);
                        this.updateUrl(product);
                    } else {
                        if (collection) {
                            this.setLoadingState(true);
                            this.renderData(collection);
                            this.updateUrl(collection);
                        }
                    }
                });
            });

            this.btnBack.addEventListener("click", (e) => {
                this.showDefault();
                this.updateUrl();
            })

            this.btnRemoves.forEach(btn => {
                btn.addEventListener("click", (e) => {
                    const card = btn?.dataset.card;
                    const collection = btn?.dataset.collection;
                    const product = btn?.dataset.product;

                    this.currentCard = card;
                    this.currentCollection = collection;
                    this.currentProduct = product;

                    this.saveDataLStorage(btn.dataset.card, null, null);
                    this.updateCardImages();
                })
            });

            // Popup Product
            this.ajaxProductPopupClose.addEventListener("click", (e) => {
                this.ajaxProduct.classList.remove('is-open');
            })
        }

        /**
         * COLLECTION AJAX
         */
        async renderData(collection = null) {
            if (collection ) {
                const url = `${window.routes.root}collections/${collection}`
                
                await fetch(url)
                .then((response) => response.text())
                .then((html) => {
                    const DOMHtml = new DOMParser().parseFromString(html, "text/html")
                    const scriptFilter = DOMHtml?.querySelector(".js-filter-script");
                    const collectionData = DOMHtml?.querySelector("#Collection");
                    if (this.ajaxContent && collectionData && scriptFilter) {
                        this.ajaxContent.innerHTML = collectionData?.innerHTML;
                    }

                    //Remove no need element from DOM
                    const removeElements = ['.collection-banner', '.collection-description', '.coll-add-nav'];
                    this.removeDOMElements(this.ajaxContent, removeElements);

                    // Force url not change when apply filter
                    this.ajaxContent.setAttribute('data-no-change-url',true)

                    // Custom ADD TO STACK Work
                    this.addQuickAddButtonsListener();
                  

                    //Handle on click product card link
                    // this.handleSelectCardAjax();

                    // Re run filter script
                    scriptFilter ? this.reloadScriptFilter(scriptFilter) : null;
                })
                .catch((err) => {
                    console.error(err);
                })
                .finally(() => {
                    this.setLoadingState(false);
                    this.hideDefault();
                });
            } else {
                // render default page
                this.showDefault();
            }
        }

        addQuickAddButtonsListener() {
            setInterval(() => {
                try {
                    if (!this.ajaxContent) return;

                    const quickAddButtons = this.ajaxContent.querySelectorAll('.quick-add-wrapper .quick-add-to-cart');
                    
                    if (quickAddButtons && quickAddButtons.length > 0) {
                        quickAddButtons.forEach(btn => {
                            try {

                                const isSoldOut = btn.dataset.soldOut === 'true';
                                if (isSoldOut) {
                                    btn.disabled = true;
                                    btn.classList.add('is-disabled'); 
                                } else {
                                    btn.disabled = false;
                                    btn.classList.remove('is-disabled');
                                }

                                if (!btn.classList.contains('build-stack-add')) {
                                    btn.classList.remove('quick-add-to-cart');
                                    btn.classList.add('build-stack-add');
                                }
                            } catch (err) {
                                console.error('Error processing quickAdd button:', err);
                            }
                        });
                    }

                    const buildStackButtons = this.ajaxContent.querySelectorAll('.build-stack-add');
                    if (buildStackButtons && buildStackButtons.length > 0) {
                        buildStackButtons.forEach(btn => {
                            try {
                                if (btn.dataset.listenerAttached !== 'true') {
                                    btn.addEventListener('click', (e) => {
                                        try {
                                            e.preventDefault();
                                            e.stopPropagation();

                                            const variantId = btn.dataset.variantId || btn.dataset.defaultVariantId;
                                            const productHandle = btn.dataset.productHandle;
                                            const productTitle = btn.dataset.productTitle;
                                            const productImage = btn.dataset.productImage;
                                            const variantTitle = btn.dataset.variantTitle;
                                            const variantPrice = btn.dataset.variantPrice;

                                            if (!variantId || !productHandle) {
                                                console.error('Missing product data');
                                                return;
                                            }

                                            const selectedVariant = {
                                                id: variantId,
                                                name: productTitle,
                                                handle: productHandle,
                                                title: variantTitle || 'Default',
                                                price: variantPrice,
                                                featured_image: {
                                                    src: productImage,
                                                    alt: productTitle
                                                }
                                            };

                                            this.saveDataLStorage?.(this.currentCard, selectedVariant, productImage);
                                            this.checkBtnReviewAndAddToCart?.();
                                            this.makeShareUrl?.();
                                            this.updateCardImages?.();
                                            this.showDefault?.();
                                            this.updateUrl?.();
                                        } catch (clickErr) {
                                            console.error('Click event error:', clickErr);
                                        }
                                    });

                                    btn.dataset.listenerAttached = 'true';
                                }
                            } catch (btnErr) {
                                console.error('Error adding listener to button:', btnErr);
                            }
                        });
                    }
                } catch (outerErr) {
                    console.error('Error in addQuickAddButtonsListener interval:', outerErr);
                }
            }, 2000);
        }


        reloadScriptFilter(script) {
            const newScript = document.createElement('script');
            newScript.textContent = script.textContent;
            this.ajaxContent.appendChild(newScript);

            // New toggle filter func
            const filterSideBar = this.ajaxContent.querySelector('.filterbar');
            const open = this.ajaxContent.querySelector('.btn-filter');
            const close = this.ajaxContent.querySelector('.closeFilter');

            open.addEventListener('click', () => { filterSideBar.classList.add('active') });
            close.addEventListener('click', () => { filterSideBar.classList.remove('active') });

            document.body.addEventListener('click', (event) => {
                const target = event.target;
                const filterBar = document.querySelector('.filterbar');
                const isFilterButton = target.classList.contains('btn-filter');
                const isFilterBarOrInside = filterBar.contains(target);
            
                // Only remove 'active' if the click is outside both the filter bar and the filter button
                if (!isFilterBarOrInside && !isFilterButton) {
                    filterSideBar.classList.remove('active');
                }
            });

            this.changeUrlOnfilter();
        }
        
        handleSelectCardAjax() {
            document.addEventListener('click', (event) => {
                if (event.target.classList.contains('js-product-link')) {
                    event.preventDefault();
                    this.showCardAjax(event.target.href);
                }
            });
        }

         /**
         * FILTER COLLECTION
         */

        changeUrlOnfilter() {
            // const filterSideBar = this.ajaxContent.querySelector('.filterbar');
            // const filterInputs = filterSideBar?.querySelectorAll('.js-filter-input');

            // filterInputs?.forEach(input => {
            //     input.addEventListener('change', ()=> {
            //         // this.handleSelectCardAjax();
            //     })
            // });
        }

        handleClearFilter() {
            document.addEventListener('click', (event) => {
                if (event.target.classList.contains('js-filter-clear')) {
                    console.log("clicked clear filter");
                    this.renderData(this.currentCollection)
                }
            });
        }


        /**
         * PRODUCT AJAX
         */

        async showCardAjax(url) {
            if (!url || url == '') return
            this.setLoadingState(true);

            await fetch(url)
                .then((response) => response.text())
                .then((html) => {
                    const DOMHtml = new DOMParser().parseFromString(html, "text/html")
                    const productData = DOMHtml?.querySelector('#shopify-section-product-template')
                    // Append product elements
                    if (this.ajaxProductContent && productData) {
                        this.ajaxProductContent.innerHTML = productData.innerHTML;

                        //Remove no need element from DOM
                        const removeElements = ['.addon_products', '.addon_products_title', '.product-btn'];
                        this.removeDOMElements(this.ajaxProduct, removeElements);

                         // Append the script with class 'js-variants-image'
                        const scriptProdVariants = DOMHtml.querySelector('script.js-variants-image');
                        if (scriptProdVariants) {
                            // Create a new script element
                            const newScript = document.createElement('script');
                            newScript.textContent = scriptProdVariants.textContent;
                            this.ajaxProductContent.appendChild(newScript);
                        }
                        this.ajaxProduct.classList.add('is-open')
                    }

                    this.initProductFunc();
                    this.handleAddBtn();
                    // Initialize the theme.Product function for the new product
                })
                .catch((err) => {
                    console.error(err);
                })
                .finally(() => {
                    this.setLoadingState(false);
                });
        }

        handleAddBtn() {
            const addBtn = this.ajaxProduct.querySelector('.js-add-to-cart');
            const formAdd = this.ajaxProduct.querySelector('form[action="/cart/add"]');
            formAdd?.removeAttribute('action');
            addBtn?.classList.remove('product-form__cart-submit');

            addBtn.addEventListener('click', (e) => {
                e.preventDefault();
                const selectedId = this.ajaxProduct.querySelector('#ProductSelect-product-template')?.value;
                const productTemplate = this.ajaxProduct.querySelector('#ProductJson-product-template');
                const productJson = JSON.parse(productTemplate.textContent);
                const variantJson = JSON.parse(productTemplate.textContent).variants;
                const selectedVariant = variantJson.find(variant => variant.id == selectedId)

                //Add handle product, get from fetch data of product-template select variant attribute
                selectedVariant['handle'] = this.ajaxProduct.querySelector('#ProductSelect-product-template')?.dataset.handle;
                
                this.saveDataLStorage(this.currentCard, selectedVariant, productJson.featured_image);
                this.checkBtnReviewAndAddToCart();
                this.makeShareUrl();
                this.updateCardImages();
                this.showDefault();
                this.updateUrl();
            })
        }

        initProductFunc() {
            const container = this.ajaxProduct.querySelector('#ProductSection-product-template');
            const singleOption = container.querySelector('#ProductSelect-product-template');
            const accordions = container.querySelectorAll('.tablink')
            if (!container) return;
            const initProduct =  new theme.Product(container);

            [container,singleOption].forEach(option => {
                if (option) {
                    option.addEventListener('change', () => {
                        initProduct.variants._onSelectChange();
                    });
                }
            })

            //Remove scroll to position
            accordions?.forEach(accordion => {
                const dataId = accordion.href.split('#')[1]
                accordion.setAttribute('data-id', dataId);
                accordion.href ='#';

                accordion.addEventListener('click', (e) => {
                    const contents = container.querySelectorAll(`.tab-content`);
                    contents?.forEach(content => {
                        content.style.display = 'none';

                        if (content.getAttribute('id') == accordion.dataset.id) {
                            content.style.display = 'block';
                        }
                    });
                })
            });
        }

        /**
         * REVIEW
         */

        toggleReviewBar() {
            const toggles = this.querySelectorAll('.js-toggle-review')
            const reviewBar = this.querySelector('.js-review-bar');

            toggles?.forEach(toggle => {
                toggle.addEventListener('click', (e) => {
                    e.stopPropagation();
                    reviewBar.classList.toggle('is-open');
                })
            });

            window.addEventListener('click', (event) => {
                if (!reviewBar.contains(event.target)) {
                    reviewBar.classList.remove('is-open');
                }
            })
        }

        checkBtnReviewAndAddToCart() {
            const open = this.querySelector('.js-toggle-review[aria-controls="open"]');
            const checkoutBtn = this.querySelector('.js-checkout-btn');
            const options = this.querySelectorAll('.js-assemble-checkbox');
            let emptyNameCount = 0;

            open?.setAttribute('disabled', 'disabled')
            checkoutBtn?.setAttribute('disabled', 'disabled')

            options.forEach(option => {
                const label = option.closest('label');
                label?.classList.add('is-disabled');
                option.addEventListener('change', () =>{
                    if (option.checked) {
                        checkoutBtn?.removeAttribute('disabled');
                    }
                })
            });

            for (const key in this.dataSkate) {
                if (this.dataSkate[key].name === "") {
                    emptyNameCount++;
                }
            }

            if (emptyNameCount == 0 ) {
                options.forEach(option => {
                    const label = option.closest('label');
                    label?.classList.remove('is-disabled');
                    if (option.checked) {
                        checkoutBtn?.removeAttribute('disabled');
                    }
                });
            }

            if (emptyNameCount != Number(this.totalPart)) {
                open?.removeAttribute('disabled')
            }
        }

        handleCheckout() {
            const checkoutBtn = this.querySelector('.js-checkout-btn');

            checkoutBtn.addEventListener('click', () => {
                this.reloadDataLStorage();
                const noteInput = this.querySelector('.js-assemble-checkbox:checked').value;
                const encodedNote = encodeURIComponent(noteInput);
                let checkOutUrl =`${checkoutBtn.dataset.href}/`;
                this.parts.forEach(part => {
                    console.log(this.dataSkate[part].variantId);
                    if (this.dataSkate[part].variantId != '') {
                        checkOutUrl += `${this.dataSkate[part].variantId}:1,`
                    }
                });

                if (noteInput != '') {
                    checkOutUrl = `${checkOutUrl.slice(0, -1)}?note=${encodedNote}`;
                } else {
                    checkOutUrl = checkOutUrl.slice(0, -1);
                }
                console.log(checkOutUrl, "${checkOutUrl}");
                
                window.location.href = checkOutUrl
            })
        }

        /**
         * SHARE / CLEAR / EXIT
         */
        handleActionsBlock() {
            this.handleShare();
            this.handleClear();
            this.handleExit();
        }

        handleClear() {
            const clearBuilds = this.querySelectorAll('.js-popup-actions-delete')

            clearBuilds?.forEach(clear => {
                clear.addEventListener('click', () =>{
                    this.dataSkate =  this.createNewEmptyData(this.parts);
                    this.updateCardImages();
                })
            });
        }

        handleShare() {
            const copyButton = this.querySelector('.js-popup-actions-copy');
            if (!copyButton) return
            
            copyButton.addEventListener('click', ()=> {
                const input = this.querySelector('.js-share-input');
                if (input) {
                    try {
                        navigator.clipboard.writeText(input.value)
                        copyButton.innerHTML = "Copied!"

                        setTimeout(() => {
                            copyButton.innerHTML = "Copy"
                        }, 2000);
                    } catch (err) {
                        console.error('Failed to copy text', err);
                    }
                }
            });
        }

        makeShareUrl() {
            let url = this.dataset.url + '?data=copy&';
            const input = this.querySelector('.js-share-input');

            for (const [key, valueObj] of Object.entries(this.dataSkate)) {
                if (valueObj.handle) {
                    // Add key=nameValue to the URL only if name exists
                    url += `${key}=${valueObj.handle}-id${valueObj.variantId}&`;
                }
            }

            if (input) {
                input.value = url;
                // input.value = url.slice(0, -1);
            }
        }

        handleExit() {
            const deletes = this.querySelectorAll(".js-popup-actions-delete");

            deletes?.forEach(del => {
                del.addEventListener("click", () => {
                    this.dataSkate = this.createNewEmptyData(this.parts);
                })
            });
        }

        /**
         * REUSE FUNCS
         */

        async checkCopyUrl() {
            const url = window.location.href.split('?data=copy&')[1];
        
            if (url && url !== '') {
                this.setLoadingState(true);
                const params = url.split('&');
                let matchingValues = [];
        
                // Extract collection, handle, and variantId from the URL params
                for (let param of params) {
                    const [collection, value] = param.split("=");
                    if (this.dataSkate[collection]) {
                        const handle = value.split('-id')[0];
                        const variantId = value.split('-id')[1];
        
                        matchingValues.push({
                            collection: collection,
                            handle: handle,
                            variantId: variantId
                        });
                    }
                }
        
                // Process each matching value by calling getCopyData for each
                if (matchingValues.length > 0) {
                    for (let data of matchingValues) {
                        await this.getCopyData(data);
                    }
                    this.updateCardImages();
                }
            } else {
                this.setLoadingState(true);
            }
        }
        
        async getCopyData(data) {
            const url = `${window.routes.root}products/${data.handle}?view=ajax`;
            console.log(url, "Fetching data for:", data.collection, data.handle);
        
            try {
                const response = await fetch(url);
                const html = await response.text();
                const DOMHtml = new DOMParser().parseFromString(html, "text/html");
                const productDOM = DOMHtml?.querySelector(".js-product-variants");
        
                if (productDOM) {
                    const productJson = JSON.parse(productDOM.textContent);
                    const variantJson = productJson.variants;
                    const selectedVariant = variantJson.find(variant => variant.id == data.variantId);
        
                    if (selectedVariant) {
                        selectedVariant.handle = data.handle;
        
                        // Save the data to localStorage (or your custom save function)
                        this.saveDataLStorage(data.collection, selectedVariant, productJson.featured_image);
                    }
                }
            } catch (err) {
                console.error("Error fetching product data:", err);
            }
        }

        updatePrice() {
            const totalPrices = this.querySelectorAll('.js-total-price');
            let totalPrice = 0
            
            //Price review btn
            for (const [key, valueObj] of Object.entries(this.dataSkate)) {
                const singlePrice = this.querySelector(`.js-single-price[data-card="${key}"]`);
                if (singlePrice) {
                    singlePrice.innerHTML = ''
                }

                if (valueObj.variantprice && valueObj.variantprice !== '') {
                    totalPrice += Number(valueObj.variantprice);
                    if (Number(valueObj.variantprice) !== 0 && singlePrice) {
                        singlePrice.innerHTML = this.formatMoney(Number(valueObj.variantprice));
                    }
                }
            }

            totalPrices?.forEach(price => {
                price.innerHTML = '';
                if (Number(totalPrice) !== 0 ) {
                    price.innerHTML = this.formatMoney(Number(totalPrice));
                }
            });
        }

        updateCardImages() {
            this.reloadDataLStorage();
        
            this.items.forEach((item, index) => {
                const image = item.querySelector('.js-image');
                const title = item.querySelector('.js-title');
                const card = item.dataset.card;
                const collection = item.dataset.collection;
                const defaultImageUrl = item.dataset.defaultUrl;
        
                // Check if the collection exists in dataSkate
                const dataSkateCollection = this.dataSkate[card];
        
                // Reset item dataset
                item.dataset.replaced = "false";
        
                // Check if the item has data in localStorage
                const itemHasData = dataSkateCollection && dataSkateCollection.name !== '' && dataSkateCollection.imageSrc !== '';
                const itemNotSameLocal = dataSkateCollection && dataSkateCollection.name === '' && dataSkateCollection.name !== title.innerHTML;
        
                if (itemHasData) {
                    // Update the title and image with stored data
                    title.innerHTML = dataSkateCollection.name;
                    image.src = dataSkateCollection.imageSrc;
                    image.alt = dataSkateCollection.imageAlt || collection;
                    image.setAttribute('data-src', dataSkateCollection.imageSrc);
                    item.dataset.replaced = "true";
                } else {
                    // Use default values if no data is found in localStorage
                    title.innerHTML = item.dataset.defaultTitle;
                    image.src = defaultImageUrl;
                    image.alt = collection;
                    item.dataset.replaced = "false";
                }
        
                if (itemNotSameLocal) {
                    title.innerHTML = item.dataset.defaultTitle;
                    image.src = defaultImageUrl;
                    image.alt = collection;
                    item.dataset.replaced = "false";
                }
            });
            this.setLoadingState(false);
            this.makeShareUrl();
        }

        removeDOMElements(target, remove) {
            remove.forEach(selector => {
                const elements = target.querySelectorAll(selector);
                elements?.forEach(ele => {
                    if (ele) {
                        ele.remove()
                    }
                });
            });
        }

        updateUrl(part = null) {
            let url = this.dataset.url;
            let newUrl = '';

            if (part) {
                newUrl = url.includes('view=') ? url.split('view=')[0] + `view=${part}` : `${url}/view=${part}`; // Remove old view=.. existed and append new view
            } else {
                newUrl = url.includes('view=') ? url.split('view=')[0] : url; // Remove old view=.. get page url only
            }
            history.pushState("", "", newUrl);
        }

        setLoadingState(state) {
            document.body.classList[state ? "add" : "remove"]("loading");
        }

        getDataLStorage() {
            const storedData = localStorage.getItem(this.keyLS);
        
            if (storedData && storedData !== "undefined") {
                try {
                    return JSON.parse(storedData);
                } catch (e) {
                    console.error("Error parsing stored data:", e);
                    return this.createNewEmptyData();
                }
            } else {
                return this.createNewEmptyData();
            }
        }

        saveDataLStorage(key = this.currentCard, object = null, productImg = null) {
            this.dataSkate = this.getDataLStorage();
            if (object) {
                if (this.dataSkate[key]) {
                    this.dataSkate[key].name = object.name;
                    this.dataSkate[key].handle = object.handle;

                    //In case variant image null
                    if (!object.featured_image) {
                        this.dataSkate[key].imageSrc = productImg
                        this.dataSkate[key].imageAlt = object.handle;
                    } else {
                        this.dataSkate[key].imageSrc = object.featured_image.src;
                        this.dataSkate[key].imageAlt = object.featured_image.alt;
                    }
                    this.dataSkate[key].variantId = object.id;
                    this.dataSkate[key].variantTitle = object.title;
                    this.dataSkate[key].variantprice = object.price;
                }
            } else {
                if (this.dataSkate[key]) {
                    this.dataSkate[key].name = "";
                    this.dataSkate[key].handle = "";
                    this.dataSkate[key].imageSrc = "";
                    this.dataSkate[key].imageAlt = "";
                    this.dataSkate[key].variantId = "";
                    this.dataSkate[key].variantTitle = "";
                    this.dataSkate[key].variantprice = "";
                }
            }
        
            localStorage.setItem(this.keyLS, JSON.stringify(this.dataSkate));
        }

        createNewEmptyData() {
            const newData = this.parts.reduce((acc, part) => {
                if (part !== '') {
                    acc[part] = this.createPartObject(part);
                }
                return acc;
            }, {});
            localStorage.setItem(this.keyLS, JSON.stringify(newData));
            return newData
        }

        createPartObject(part) {
            return {
                name: "",
                handle: "",
                imageSrc: "",
                imageAlt: "",
                variantId: "",
                variantTitle: "",
                variantprice: ""
            };
        };

        showDefault() {
            this.defaultContent?.classList.add('is-open');
            this.ajaxContent?.classList.remove('is-open');
            this.ajaxProduct?.classList.remove('is-open');
            this.ajaxProductContent.innerHTML = "";
            this.btnBack?.classList.remove('is-open');
            this.updateUrl();
            this.scrollToTop();
            // this.checkBtnReviewAndAddToCart();
        }

        hideDefault() {
            this.defaultContent?.classList.remove('is-open');
            this.ajaxContent?.classList.add('is-open');
            this.btnBack?.classList.add('is-open');
            this.scrollToTop();
        }

        formatMoney(cents, format = "") {
            var value = "",
              placeholderRegex = /\{\{\s*(\w+)\s*\}\}/,
              formatString = format || "${{amount}}";
          
            if (typeof cents == "string") cents = cents.replace(".", "");
          
            function defaultOption(opt, def) {
              return typeof opt == "undefined" ? def : opt;
            }
          
            function formatWithDelimiters(number, precision, thousands, decimal) {
              precision = defaultOption(precision, 2);
              thousands = defaultOption(thousands, ",");
              decimal = defaultOption(decimal, ".");
          
              if (isNaN(number) || number == null) {
                return 0;
              }
          
              number = (number / 100.0).toFixed(precision);
          
              var parts = number.split("."),
                dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + thousands),
                cents = parts[1] ? decimal + parts[1] : "";
          
              return dollars + cents;
            }
          
            switch (formatString.match(placeholderRegex)[1]) {
              case "amount":
                value = formatWithDelimiters(cents, 2);
                break;
              case "amount_no_decimals":
                value = formatWithDelimiters(cents, 0);
                break;
              case "amount_with_comma_separator":
                value = formatWithDelimiters(cents, 2, ".", ",");
                break;
              case "amount_no_decimals_with_comma_separator":
                value = formatWithDelimiters(cents, 0, ".", ",");
                break;
            }
          
            return formatString.replace(placeholderRegex, value);
        }

        scrollToTop(distance = null) {
            const _distance = distance || 0
            window.scrollTo({ top: _distance, behavior: "smooth" });
        }
    }
    customElements.define("build-skate", BuildSkate);
  }